import type { QueryApi } from "../../api/query";

export function createUseAmazonStatisticsSummary($api: QueryApi) {
  return function useAmazonStatisticsSummary(options?: { enabled?: boolean }) {
    return $api.useQuery("get", "/amazon-statistics/summary", {}, {
      staleTime: 5 * 60_000,
      ...options,
    });
  };
}
